import React from "react";

import AboutSubHero from "../components/about/aboutSubHero";
import CallToAction from "../components/general/callToAction";
import OurTeam from "../components/about/ourTeam";

const About = () => {
  return (
    <>
        {/* <PageHeader title="Who We Are" breadcrumb="About Us" /> */}

        <AboutSubHero />

        <OurTeam />
        
        <CallToAction />

    </>
  );
};

export default About;